"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableDebug = void 0;
const debug_1 = __importDefault(require("debug"));
const is_server_1 = __importDefault(require("./utils/is-server"));
const rootNamespace = 'sitecore-jss';
// On server/node side, allow switching from the built-in
// `%o` (pretty-print single line) and `%O` (pretty-print multiple line)
// with a `DEBUG_MULTILINE` environment variable.
if (is_server_1.default() &&
    ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.DEBUG_MULTILINE) === 'true' &&
    debug_1.default.formatters.o &&
    debug_1.default.formatters.O) {
    debug_1.default.formatters.o = debug_1.default.formatters.O;
}
/**
 * Enable debug logging dynamically
 * @param {string} namespaces space-separated list of namespaces to enable
 */
const enableDebug = (namespaces) => debug_1.default.enable(namespaces);
exports.enableDebug = enableDebug;
/**
 * Default Sitecore JSS 'debug' module debuggers. Uses namespace prefix 'sitecore-jss:'.
 * See {@link https://www.npmjs.com/package/debug} for details.
 */
exports.default = {
    common: debug_1.default(`${rootNamespace}:common`),
    http: debug_1.default(`${rootNamespace}:http`),
    layout: debug_1.default(`${rootNamespace}:layout`),
    dictionary: debug_1.default(`${rootNamespace}:dictionary`),
    editing: debug_1.default(`${rootNamespace}:editing`),
    sitemap: debug_1.default(`${rootNamespace}:sitemap`),
    multisite: debug_1.default(`${rootNamespace}:multisite`),
    robots: debug_1.default(`${rootNamespace}:robots`),
    redirects: debug_1.default(`${rootNamespace}:redirects`),
    personalize: debug_1.default(`${rootNamespace}:personalize`),
    errorpages: debug_1.default(`${rootNamespace}:errorpages`),
};
